/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MedicareAssessmentForm } from './MedicareAssessmentForm';
import {
    MedicareAssessmentFormFromJSON,
    MedicareAssessmentFormFromJSONTyped,
    MedicareAssessmentFormToJSON,
} from './MedicareAssessmentForm';

/**
 * 
 * @export
 * @interface GetLeadAssessmentForm200Response
 */
export interface GetLeadAssessmentForm200Response {
    /**
     * 
     * @type {MedicareAssessmentForm}
     * @memberof GetLeadAssessmentForm200Response
     */
    data?: MedicareAssessmentForm;
}

/**
 * Check if a given object implements the GetLeadAssessmentForm200Response interface.
 */
export function instanceOfGetLeadAssessmentForm200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetLeadAssessmentForm200ResponseFromJSON(json: any): GetLeadAssessmentForm200Response {
    return GetLeadAssessmentForm200ResponseFromJSONTyped(json, false);
}

export function GetLeadAssessmentForm200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadAssessmentForm200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : MedicareAssessmentFormFromJSON(json['data']),
    };
}

export function GetLeadAssessmentForm200ResponseToJSON(value?: GetLeadAssessmentForm200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': MedicareAssessmentFormToJSON(value.data),
    };
}

